export default "__VITE_ASSET__CTeqDWmr__"